import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { GetAllEmployeeLeaves, GetOnlyMyLeaves, ApplyForLeave, LeaveApprovals, GetAllLeaveTypes, CreateLeaveType, UpdateLeaveType, DeleteLeaveType, GetApplicableLeaveTypes, GetRaisedLeaveRequestsByEmployee, GetLeaveRequestsForApprover, GetDashboardPendingLeaves, WithdrawLeaveRequest } from "helpers/api_method";

export const getAllEmployeeLeaves = createAsyncThunk("leaves/getAllEmployeeLeaves", async (event: any) => {
    try {
        const response = await GetAllEmployeeLeaves();
        return response;
    } catch (error) {
        return error;
    }
});

export const getMyLeaves = createAsyncThunk("leaves/getMyLeaves", async () => {
    try {
        const response = await GetOnlyMyLeaves();
        return response;
    } catch (error) {
        return error;
    }
});

export const getRaisedLeavesData = createAsyncThunk("leaves/getRaisedLeavesData", async () => {
    try {
        const response = await GetRaisedLeaveRequestsByEmployee();
        return response;
    } catch (error) {
        return error;
    }
});

export const getLeaveRequestsForApprover = createAsyncThunk("leaves/getLeaveRequestsForApprover", async () => {
    try {
        const response = await GetLeaveRequestsForApprover();
        return response;
    } catch (error) {
        return error;
    }
});

export const getDashboardPendingLeaves = createAsyncThunk("leaves/getDashboardPendingLeaves", async () => {
    try {
        const response = await GetDashboardPendingLeaves();
        return response;
    } catch (error) {
        return error;
    }
});

export const createNewLeaveRequest = createAsyncThunk("leaves/createNewLeaveRequest", async (event: any) => {
    try {
        const response = await ApplyForLeave(event);
        return response;
    } catch (error) {
        return error;
    }
});

export const approveRequests = createAsyncThunk("leaves/approveRequests", async (event: any) => {
    try {
        const response = await LeaveApprovals(event.id, event);
        return response;
    } catch (error) {
        return error;
    }
});

export const withdrawLeave = createAsyncThunk("leaves/withdrawLeave", async (leave_request_id: string) => {
    try {
        const response = await WithdrawLeaveRequest(leave_request_id);
        return response;
    } catch (error) {
        return error as any;
    }
});



export const getAllLeaveTypes = createAsyncThunk("leaves/getAllLeaveTypes", async () => {
    try {
        const response = await GetAllLeaveTypes();
        return response;
    } catch (error) {
        return error;
    }
});
export const getAllApplicableLeaveTypes = createAsyncThunk("leaves/getAllApplicableLeaveTypes", async () => {
    try {
        const response = await GetApplicableLeaveTypes();
        return response;
    } catch (error) {
        return error;
    }
});
export const createNewLeaveType = createAsyncThunk("leaves/createNewLeaveType", async (event: any) => {
    try {
        const response = await CreateLeaveType(event);
        toast.success("Leave Type created Successfully", { autoClose: 2000 });
        return response;
    } catch (error) {
        toast.error("Leave Type creation Failed", { autoClose: 2000 });
        return error;
    }
});
export const updateLeaveType = createAsyncThunk("leaves/updateLeaveType", async (event: any) => {
    try {
        const response = await UpdateLeaveType(event.id, event);
        toast.success("Leave Type Updated Successfully", { autoClose: 2000 });
        return response;
    } catch (error) {
        toast.error("Leave Type update Failed", { autoClose: 2000 });
        return error;
    }
});
export const deleteExistingLeaveType = createAsyncThunk("leaves/deleteExistingLeaveType", async (event: any) => {
    try {
        const response = await DeleteLeaveType(event.id);
        toast.success("Leave Type deleted Successfully", { autoClose: 2000 });
        return response;
    } catch (error) {
        toast.error("Leave Type deletion Failed", { autoClose: 2000 });
        return error;
    }
});